import React, { useMemo, useEffect, useState } from 'react';
import styled from 'styled-components';
import PitchSidemenu from './PitchSidemenu';
import { Calibration, models } from '@balljames/calibration';
import { RouteComponentProps, Prompt } from 'react-router';
import { usePitch } from './usePitches';
import useSessionVideo, { useSnapshot } from './useSessionVideo';

type TParams = { video: string; pitch: string };
interface Props extends RouteComponentProps<TParams> {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const Container1 = styled.div`
  height: 100%;
  flex: 0 1 250px;
`;

const Container2 = styled.div`
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  box-sizing: border-box;
  overflow: auto;
  display: inline-block;
`;

const PitchVideoCalibration: React.FunctionComponent<Props> = (props) => {
  const pitch = usePitch(props.match.params.pitch);
  const video = useSessionVideo(props.match.params.video);
  const snapshot = useSnapshot(props.match.params.video);
  const [image, setImage] = useState<HTMLImageElement>();
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    var img = new Image();

    img.width = video?.width || 0;
    img.height = video?.height || 0;
    img.src = 'data:image/png;base64,' + snapshot;
    img.onload = () => {
      setImage(img);
    };
  }, [video, snapshot]);

  const model = useMemo(() => {
    if (pitch?.type)
      return (models as { [key: string]: any })[pitch.type](
        (pitch?.fieldWidth || 68000) / 1000,
        (pitch?.fieldLength || 105000) / 1000
      );
    return models.FullPitchExtendedModel(
      (pitch?.fieldWidth || 68000) / 1000,
      (pitch?.fieldLength || 105000) / 1000
    );
  }, [pitch]);

  return (
    <Wrapper>
      <Container1>
        <PitchSidemenu />
      </Container1>
      <Container2 className="sciui-card sciui-m-l sciui-p-l sciui-bg-p-5">
        <Prompt when={dirty} message="You have unsaved changes to the calibration, are you sure?" />
        {snapshot && video && image && (
          <Calibration
            model={model}
            image={image}
            baseUrl={process.env.REACT_APP_CALIBRATION_URL}
            defaultProjection
            readonly
            saveCalibration={() => {}}
            setDirty={setDirty}
            previousPoints={
              video.clickPoints ? JSON.parse(video.clickPoints) : undefined
            }
            previousCalibration={
              video.calibration ? JSON.parse(video.calibration) : undefined
            }
            cameraType="Universal"
          />
        )}
      </Container2>
    </Wrapper>
  );
};

export default PitchVideoCalibration;
